
interface CidadeSchemasProps {
  faqItems: Array<{
    question: string;
    answer: string;
  }>;
  cidadeFormatted: string;
  estadoNome: string;
  currentUrl: string;
  estado: string;
}

const CidadeSchemas = ({ faqItems, cidadeFormatted, estadoNome, currentUrl, estado }: CidadeSchemasProps) => {
  // Create FAQ Schema for JSON-LD
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": faqItems.map(item => ({
      "@type": "Question",
      "name": item.question,
      "acceptedAnswer": {
        "@type": "Answer",
        "text": item.answer
      }
    }))
  };

  // Service Schema for this specific city
  const serviceSchema = {
    "@context": "https://schema.org",
    "@type": "Service",
    "name": `Serviços de SEO Local em ${cidadeFormatted}`,
    "description": `Estratégias de SEO local personalizadas para empresas em ${cidadeFormatted}, ${estadoNome}, para aumentar sua visibilidade nas buscas do Google e atrair mais clientes locais.`,
    "provider": {
      "@type": "Organization",
      "name": "LocalUp",
      "areaServed": {
        "@type": "City",
        "name": cidadeFormatted,
        "containedInPlace": {
          "@type": "State",
          "name": estadoNome
        }
      }
    },
    "serviceArea": {
      "@type": "City", 
      "name": cidadeFormatted,
      "containedInPlace": {
        "@type": "State",
        "name": estadoNome
      }
    }
  };

  // LocalBusiness Schema
  const localBusinessSchema = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "name": `LocalUp - SEO Local para empresas em ${cidadeFormatted}`,
    "description": `Serviços de SEO Local especializado para empresas em ${cidadeFormatted}, ${estadoNome}.`,
    "url": currentUrl,
    "areaServed": {
      "@type": "City",
      "name": cidadeFormatted,
      "containedInPlace": {
        "@type": "State",
        "name": estadoNome
      }
    },
    "address": {
      "@type": "PostalAddress",
      "addressLocality": cidadeFormatted,
      "addressRegion": estado
    }
  };

  // Breadcrumb Schema
  const breadcrumbSchema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      {
        "@type": "ListItem",
        "position": 1,
        "name": "Home",
        "item": "https://www.localup.com.br/"
      },
      {
        "@type": "ListItem",
        "position": 2,
        "name": "Cidades",
        "item": "https://www.localup.com.br/cidades"
      },
      {
        "@type": "ListItem",
        "position": 3,
        "name": estadoNome,
        "item": `https://www.localup.com.br/estado/${estado.toLowerCase()}`
      },
      {
        "@type": "ListItem",
        "position": 4,
        "name": cidadeFormatted,
        "item": currentUrl
      }
    ]
  };

  return {
    faqSchema,
    serviceSchema,
    localBusinessSchema,
    breadcrumbSchema
  };
};

export default CidadeSchemas;
